/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './tableHeaders/history';
import TableSkeleton from '/client/src/components/skeletons/dataTableSkeleton';
import { GET } from '/client/src/api';

type PropsType = {
    eventId: string | number,
    checkInUpdated: boolean
};

const CheckInEventHistory = ({ eventId, checkInUpdated }: PropsType): React.Element<'div'> => {
    const [pending, setPending] = React.useState(true);
    const [rows, setRows] = React.useState([]);
    const [skipCount, setSkipCount] = React.useState(0);
    const [totalRows, setTotalRows] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [maxResultCount, setMaxResultCount] = React.useState(100);
    const [sortString, setSortString] = React.useState('checkin_time_utc+desc');

    const fetchData = async () => {
        try {
          /* eslint-disable */
          const url = `/api/v1/1/events/${eventId}/attendees?max_result_count=${maxResultCount}&skip_count=${skipCount}&has_voided=false&sorting=${sortString}&has_checked=true`;
    
          setPending(true);

          const { result } = await GET(url);
    
          setRows(result.items); 
          setTotalRows(result.total_count);
          setPending(false);

        } catch (e) {
          console.log(e);
          console.error('Cant get history');
          setPending(false);
        }
      };

      const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setSkipCount(page * maxResultCount - maxResultCount);
      };
    
      const handleMaxResultCount = (count: number) => {
        setMaxResultCount(count);
        setSkipCount(currentPage * count - count);
      };

      React.useEffect(() => {
        fetchData();
      }, [eventId, skipCount, maxResultCount, sortString, checkInUpdated]);

    return (
      <div className='checkin-history-container'>
        <DataTable
          columns={columns()}
          defaultSortField={'checkin_time_utc'}
          defaultSortAsc={false}
          data={rows}
          sortServer
          onSort={(column, sortDirection): void => setSortString(`${column.selector}+${sortDirection}`)}
          highlightOnHover
          pointerOnHover
          pagination
          paginationPerPage={maxResultCount}
          paginationServer
          paginationTotalRows={totalRows}
          paginationDefaultPage={currentPage}
          paginationRowsPerPageOptions={[100, 500, 1000]}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleMaxResultCount}
          responsive
          striped
          fixedHeader
          noHeader
          persistTableHead
          progressPending={pending}
          progressComponent={<TableSkeleton rows={maxResultCount} columns={columns()} />}
          sortIcon={(): React.Element<typeof React.Fragment> => {
          return (
            <>
              <span className="-sort-desc" />
              <span className="-sort-asc" />
            </>
          );
        }}
        />
        </div>
    );
};

export default CheckInEventHistory;